import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import {
  instance2,
  PRIMARY_BACKGROUND,
  DEFAULT_BOX_SHADOW,
  TYPE_INSTANCE2,
  // instance1,
} from "App/constants";
import { fetchData } from "App/utils/helpers";
import { getAllKelasKamar } from "../../TabKelasKamar/helpers";
import { getAllSirsOnline, getListRuangSirsOnline } from "../../TabKelasKamarSirsOnline/helpers";
import { getAllGolonganKelas } from "../../TabGolonganKelas/helpers";
import { MasterButton } from "App/Component/ui";
import { LIST_URL_MASTER } from "utils/masters";

export const RESET_STATE_TAB_BED = {
  id: "",
  name: "",

  kelas_id: null,
  kelas_name: "Pilih Kelas Kamar",

  kelaskamarsirsonline: null,
  kelaskamarsirsonline_name: "Pilih Sirs Online",

  kamar_id: null,
  kamar_name: "Pilih Kamar",

  gol_golongankelasaplicares: null,
  gol_golongankelasaplicares_name: "Pilih Golongan Kelas Aplicare",

  ruang_aplicares: null,
  ruang_aplicares_name: "Pilih Ruang Aplicare",

  ruang_sirsonline: null,
  ruang_sirsonline_name: "Pilih Ruang SIRS Online",

  jenis_layanan_id: null,
  jenis_layanan_name: "Pilih Layanan",

  icekbridging: 1,
  icekbridging_sirsonline: 1,

  remark: "",
  status: 1,
};

export const RESET_FILTER_TAB_BED = {
  id: "",
  nama: "",
  kelas_id: null,
  kelas_name: "Pilih Kelas Kamar",
  kamar_name: "Pilih Kamar",

  ruang_aplicares_name: "Pilih Ruang Aplicare",
  ruang_aplicares: null,
  status: "",
};

export const getAllBed = async (formFilter) => {
  try {
    const api = await instance2.get(LIST_URL_MASTER.bed.list, {
      headers: {
        id: formFilter.id,
        nama: formFilter.nama,
        status: formFilter.status,
        ruang_aplicares:
          formFilter.ruang_aplicares === null ? "" : formFilter.ruang_aplicares,
        kelas_id: formFilter.kelas_id === null ? "" : formFilter.kelas_id,
        kamar_nama:
          formFilter.kamar_name === null ||
          formFilter.kamar_name === "Pilih Kamar"
            ? ""
            : formFilter.kamar_name,
      },
    });
    const res = api.data;
    return {
      state: true,
      data: res.body,
    };
  } catch (error) {
    return {
      state: false,
      data: [],
      message: error?.response?.data?.message,
    };
  }
};

export const deleteBedById = async (id) => {
  try {
    await instance2.post(
      LIST_URL_MASTER.bed.delete,
      {},
      {
        headers: {
          idbed: id,
        },
      }
    );
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "ruang_aplicares",
    disablePadding: false,
    label: "RUANG APLICARE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name_kelaskamar",
    disablePadding: false,
    label: "KELAS KAMAR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name_ruangkamar",
    disablePadding: false,
    label: "RUANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name_golongankelasaplicare",
    disablePadding: false,
    label: "GOL KELAS APLICARES",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "name_kamar",
    disablePadding: false,
    label: "KAMAR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name_kelassirsonline",
    disablePadding: false,
    label: "KLS KAMAR SIRS ONLINE",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "center",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const STYLE_DEFAULT_TAB_BED = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const useInitialKelasKamarAplicares = () => {
  const [state, setState] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await getAllKelasKamar(LIST_URL_MASTER.bed.list_kelas_kamar);

      if (res) {
        const data = [];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, []);

  return state;
};

export const useInitialSirsOnline = () => {
  const [state, setState] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await getAllSirsOnline(LIST_URL_MASTER.bed.list_sirs_online);

      if (res) {
        const data = [];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, []);

  return state;
};

export const useInitialRuangSirsOnline = () => {
  const [state, setState] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await getListRuangSirsOnline();

      if (res) {
        const data = [];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, []);

  return state;
};

export const useInitialGolonganKelas = () => {
  const [state, setState] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await getAllGolonganKelas(
        LIST_URL_MASTER.bed.list_golongan_kelas
      );

      if (res) {
        const data = [];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
            kode_ruang_aplicares: item.kode_ruang_aplicares,
          });
        });

        setState(data);
      }
    })();
  }, []);

  return state;
};

export const useInitialKamar = () => {
  const [state, setState] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await fetchData(
        TYPE_INSTANCE2,
        LIST_URL_MASTER.bed.list_kamar
      );

      if (res) {
        const data = [];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, []);

  return state;
};

export const getJenisLayananByRawatInap = async () => {
  try {
    const api = await instance2.get(
      "/jenis_layanan/listjenis_layanan_rinapbed"
    );
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const getRuangAplicare = async () => {
  try {
    const api = await instance2.get(LIST_URL_MASTER.ruang_aplicares.list);
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const useInitialRuangAplicare = () => {
  const [state, setState] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await getRuangAplicare();
      if (res) {
        const data = [];
        res.map((item) => {
          return data.push({
            value: item.kode,
            label: `[${item.kode}] ${item.name}`,
          });
        });

        setState(data);
      }
    })();
  }, []);

  return state;
};

export const useInitialJenisLayanan = () => {
  const [state, setState] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await getJenisLayananByRawatInap();

      if (res) {
        const data = [];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, []);

  return state;
};

export const StatusBed = ({ status }) => {
  if (parseInt(status) === 0) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Non-Aktif"}
        color={"secondary"}
        type="button"
        disabled
      />
    );
  } else if (parseInt(status) === 1) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Aktif"}
        color={"green"}
        type="button"
        disabled
      />
    );
  } else {
    return <>-</>;
  }
};

export const getTagBedList = async (id_bed) => {
  try {
    const api = await instance2.get("/bed/list-bed-tag-by-id-bed", {
      params: {
        id_bed,
      },
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const addTagBedList = async (data, create = false) => {
  try {
    const api = await instance2.post("/bed/add-bed-tag", {
      id_bed: data.id_bed,
      id_bed_tag: data.id_bed_tag,
      remark: "",
      is_create_tag: create,
      kategori_tag: "BED",
      nama_tag: data.nama_tag,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: res.message,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteTagBedList = async (data) => {
  try {
    const api = await instance2.post("/bed/delete-bed-tag", {
      id: data.id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: res.message,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
